// src/components/AdminRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import NotFound from './NotFound';

/**
 * Guards the /admin route on the client.
 *
 * NOTE: this is a UX guard only — the real security boundary is the backend
 * requirePlatformAdmin middleware on /api/admin/*. A non-admin who forces the
 * route open still gets 403s from every admin API call.
 *
 *  - not signed in        → bounce to the app (which shows the login screen)
 *  - signed in, not admin → render 404 (don't advertise that /admin exists)
 *  - signed in + admin     → render the dashboard
 */
export default function AdminRoute({ children }) {
    const { user, loading } = useContext(UserContext);

    if (loading) return null;
    if (!user) return <Navigate to="/" replace />;
    if (!user.isPlatformAdmin) return <NotFound />;

    return children;
}
